import React, { useState } from "react";
import { Tabs as Abas, Tab, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import styled from "styled-components";
import TabConcur from "./TabConcur";
import TabEmpresa from "./TabEmpresa";
import TabMapeamento from "./TabMapeamento";
import TabSettings from "./TabSettings";
import TabVencimento from "./TabVencimento";
import TabCurrencies from "./TabCurrencies";


function Tabs({ touched, values, errors, handleChange, initValues, formik, setFieldValue }) {
  const [tabIndex, setTabIndex] = useState(0);
  const { empresa = [] } = values;
  return (
    <ModernContainer>
      <Abas selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab>Credencial</Tab>
          <Tab>Empresas</Tab>
          <Tab>Data Vencimento</Tab>
          <Tab>Mapeamento</Tab>
          <Tab>Configurações</Tab>
          <Tab>Moedas</Tab>
        </TabList>
        <TabPanel>
          <TabConcur
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            formik={formik}
          />
        </TabPanel>
        <TabPanel>
          <TabEmpresa
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            initialValues={empresa}
          />
        </TabPanel>
        <TabPanel>
          <TabVencimento
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            initialValues={empresa}
            setFieldValue={setFieldValue}
          />
        </TabPanel>
        <TabPanel>
          <TabMapeamento
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            initialValues={empresa}
            setFieldValue={setFieldValue}
          />
        </TabPanel>
        <TabPanel>
          <TabSettings
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            formik={formik}
          />
        </TabPanel>
        <TabPanel>
          <TabCurrencies values={values} setFieldValue={setFieldValue} />
        </TabPanel>
      </Abas>
    </ModernContainer>
  );
}

const ModernContainer = styled.div`
  width: 100%;
  font-family: 'Mulish', sans-serif;

  .react-tabs {
    -webkit-tap-highlight-color: transparent;
  }

  .react-tabs__tab-list {
    border-bottom: 2px solid #e2e8f0 !important;
    margin: 0 0 24px !important;
    padding: 0 !important;
    display: flex !important;
    gap: 8px !important;
    flex-wrap: wrap !important;
  }

  .react-tabs__tab {
    padding: 12px 24px !important;
    border: none !important;
    background: transparent !important;
    cursor: pointer !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #64748b !important;
    border-bottom: 3px solid transparent !important;
    transition: all 0.3s ease !important;
    font-family: 'Mulish', sans-serif !important;
    outline: none !important;
    list-style: none !important;
    position: relative !important;
    margin: 0 !important;

    &:hover {
      color: #667eea !important;
      background: rgba(102, 126, 234, 0.05) !important;
      border-radius: 8px 8px 0 0 !important;
    }
  }

  .react-tabs__tab--selected {
    color: #667eea !important;
    border-bottom-color: #667eea !important;
    background: rgba(102, 126, 234, 0.05) !important;
    border-radius: 8px 8px 0 0 !important;
  }

  .react-tabs__tab--disabled {
    color: #cbd5e1 !important;
    cursor: not-allowed !important;

    &:hover {
      color: #cbd5e1 !important;
      background: transparent !important;
    }
  }

  .react-tabs__tab:focus {
    box-shadow: none !important;
  }

  .react-tabs__tab-panel {
    display: none !important;
    animation: fadeIn 0.3s ease !important;
  }

  .react-tabs__tab-panel--selected {
    display: block !important;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export default Tabs;
